import { render, staticRenderFns } from "./DmrSection.vue?vue&type=template&id=7a831cf6&"
import script from "./DmrSection.vue?vue&type=script&lang=js&"
export * from "./DmrSection.vue?vue&type=script&lang=js&"
import style0 from "./DmrSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports